import { getHuminizeDurationInSecFunction } from 'i18n/dateLocale';

const humanize = getHuminizeDurationInSecFunction(['m', 's'], true);

export const parseCompactTime = (value: number, unit: string) => {
  if (!unit) {
    return value.toString();
  }

  if (unit.toLowerCase() === 'h') {
    return `${humanize(value * 60 * 60)}`;
  } else if (unit.toLowerCase() === 'm') {
    return `${humanize(value * 60)}`;
  } else if (unit.toLowerCase() === 's') {
    return `${humanize(value)}`;
  } else {
    return `${value} ${unit}`;
  }
};
